module.exports = __webpack_public_path__ + "img/christophe_mae-vie_artiste.8a98e89f.jpg";